module.exports = __webpack_public_path__ + "img/service-point-sharff-3.3a585ac8.svg";